<template>
  <div>

    <div class="main" v-if="subsState=='summary'" :class="dyhState==1?'wid1':'wid2'">
      <div class="cardbg">
        <div class="title">
          <span>账户信息</span>
        </div>
        <a-row>
          <a-col :span="6">
            <div class="content">
              <p>手机号</p>
              <a-input v-model="userInfo.mobile" class="input" disabled  placeholder="" />
              <p>密码</p>
              <a-input v-model="userInfo.password" class="input" placeholder="8-16位，留空为不修改" />
            </div>
          </a-col>
          <a-col :span="6">
            <div class="content">
              <p>&nbsp;</p>
              <div style="display: flex">
                <a-input style="width: 50%" v-model="userInfo.codeValue" placeholder="请输入验证码" />
                <a-button style="
              background: #FF373C;
              border-radius: 2px;
              color: #fff;margin-left: 4%;width: 45%" @click="getAuthCode" v-if="firstCode">获取验证码</a-button>
                <a-button style="
              background: #FF373C;
              border-radius: 2px;
              color: #fff;margin-left: 4%;width: 45%;" :style="{opacity: disabled?'0.5':'1'}" @click="getAuthCode" v-else :disabled="disabled">
                  <span v-show="expireTime<60&&expireTime>0">{{expireTime}}</span>
                  重新获取
                </a-button>
              </div>
            </div>
          </a-col>
        </a-row>

      </div>
      <div class="deliver"></div>
      <div v-if="subsDataList.length==0">
        <div class="subsbg">
          <div class="title">
            <span>订阅号</span>
          </div>
          <div class="content1">
            <div class="imgbg"><img src="@/assets/icon/apply.png" alt=""/></div>
            <p class="txt">
              <span class="p1">还没有申请</span>
              <span class="p2" @click="applySubscribe">去申请</span>
            </p>
          </div>
        </div>
        <div class="deliver"></div>
      </div>
      <div v-else>
        <div v-for="(item,i) in subscribeInfo">
          <div class="subsbg" v-if="item.auditorStatus==1 && subsDataList[0].status==0">
            <div class="title">
              <span>订阅号</span>
            </div>
            <div class="content1">
              <div class="imgbg"><img src="@/assets/icon/refuse.png" alt=""/></div>
              <p class="txt">
                <span class="p1">该订阅号已停用</span>
<!--                <span class="p2" @click="reasonVisible=true">查看原因</span>-->
<!--                <span class="p1">或</span>-->
<!--                <span class="p2" @click="applyAgain">重新申请</span>-->
              </p>
            </div>
          </div>
          <div class="subsbg" v-if="item.auditorStatus==0">
            <div class="title">
              <span>订阅号</span>
            </div>
            <div class="content1">
              <div class="imgbg"><img src="@/assets/icon/wait.png" alt=""/></div>
              <p class="txt">
                <span class="p1">您的信息正在审核中，请耐心等待</span>
              </p>
            </div>
          </div>
          <div class="subsbg" v-if="item.auditorStatus==2">
            <div class="title">
              <span>订阅号</span>
            </div>
            <div class="content1">
              <div class="imgbg"><img src="@/assets/icon/refuse.png" alt=""/></div>
              <p class="txt">
                <span class="p1">您提交的申请被驳回，您可以</span>
                <span class="p2" @click="reasonVisible=true">查看原因</span>
                <span class="p1">或</span>
                <span class="p2" @click="applyAgain">重新申请</span>
              </p>
            </div>
          </div>
          <div class="subsbg" v-if="item.auditorStatus==1 && subsDataList[0].status==1">
            <div class="title">
              <span>订阅号</span>
            </div>
            <div class="content2">
              <div class="imgbg" v-if="subsDataList[0].logoUrl"><img :src="subsDataList[0].logoUrl" alt=""/></div>
              <div class="imgbg" v-else><img src="@/assets/layout/2-1.png" alt=""/></div>
              <div class="txtcontent">
                <div class="row">
                  <span class="color1 font18">{{subsDataList[0].name}}</span>
                  <span class="color2 font14">订阅号</span>
                  <a-icon type="edit" style="color: #FF373C" @click="applyAgain"/>
                </div>
                <div class="row" style="display: none">
                  <span class="color1 font14">三级甲等</span>
                  <span class="color2 font14">综合医院</span>
                  <a-divider class="deli" type="vertical"/>
                  <span class="color2 font14">南京市骨科</span>
                  <span class="color1 font14">医院联盟</span>
                  <a-divider class="deli" type="vertical"/>
                  <span class="color2 font14">曹泽平</span>
                  <span class="color1 font14">主任医师</span>
                </div>
                <div class="row">
              <span class="color2 font14">
                {{subsDataList[0].desc}}
              </span>
                </div>
              </div>
            </div>
          </div>
          <div class="deliver"></div>
        </div>

      </div>
      <a-modal class="mod" v-model="reasonVisible" title="驳回原因"
               ok-text="确认" cancel-text="取消"
               @ok="handleOk">
        <p class="point" v-if="subscribeInfo.length!=0">{{subscribeInfo[0].auditorMessage}}</p>
        <p class="point" v-else>暂无...</p>
<!--        <p class="point">驳回原因2</p>-->
      </a-modal>
      <footer>
        <div class="btn">
          <div class="cacel" @click="cancel">取消</div>
          <div class="save" @click="save">保存</div>
        </div>
      </footer>
    </div>
    <subs-create @changeStatus="changeStatus"
                 :subsState="subsState"
                 :editForm="editForm"
                 :subsId="subsId"
                 v-if="subsState=='create'||subsState=='edit'"/>
  </div>
</template>

<script>
import subsCreate from './create/index'
import { getSubsInfo, sendSms } from '@/api/subscription'
import {forgetPassword} from '@/api/userManage'
import getMD5 from "@/plugins/getMD5";
import {mapGetters} from "vuex";
import {validatePassword} from '@/plugins/validate'

export default {
  components:{
    subsCreate
  },
  computed: {
    ...mapGetters(["dyhState"]),
  },
  data(){
    return{
      subsId:'',
      disabled:false,
      firstCode:true,
      expireTime:60,//倒计时
      editForm:{},
      userInfo:{
        mobile:'',
        password:'',
        codeKey:'',
        codeValue:''
      },
      smsCode:'',//验证码
      subsDataList:[
        // {
        //   name:'1',
        //   status:0
        // },
        // {
        //   name:'2',
        //   status:1
        // },
        // {
        //   name:'3',
        //   status:2
        // },
        // {
        //   name:'4',
        //   status:3
        // }
      ],
      subsState:'summary',//页面状态
      reasonVisible:false,//驳回原因弹窗
      subscribeInfo:[],//订阅号用户信息
      userModel:''
    }
  },
  created() {
    this.getSubscriptionInfo()
    this.userModel=JSON.parse(localStorage.getItem("userModel")) || null
    this.userInfo.mobile=this.userModel?this.userModel.mobile:''
  },
  mounted() {
    let that=this
    if(this.userInfo.mobile==''){
      setTimeout(function (){
        that.userModel=JSON.parse(localStorage.getItem("userModel"))
        that.userInfo.mobile=that.userModel?that.userModel.mobile:''
      },2000)
    }
  },
  methods:{
    //获取验证码
    getAuthCode(){
      if(this.userInfo.mobile){
        this.sendSmsCode()
        this.showTimeOut()

      }else{
        this.$message.warning("请输入手机号!");
      }
    },
    //验证码倒计时
    showTimeOut(){
      let _this=this
      _this.firstCode=false
      _this.disabled=true
      // console.log(_this.expireTime)
      let timer = setInterval(()=>{
        if(_this.expireTime<=0){
          clearInterval(timer)
          _this.disabled=false
          this.expireTime=60
        }else{
          _this.expireTime--
          // _this.showTimeOut()
        }
      },1000)
    },
    /** 接口*/
    sendSmsCode(){
      let form={

        mobile: this.userInfo.mobile,

      }
      sendSms(form).then(res=>{
        if(res.status){
          this.userInfo.codeKey=res.data.data
        }else{
          this.$message.warning(res.message+' 请稍后重试')
        }
      })
    },
    // 切换状态
    changeStatus(val){
      this.subsState=val
      if(val=='summary'){
        this.getSubscriptionInfo()
      }
    },
    //取消
    cancel(){
      this.userInfo.password=''
      this.userInfo.codeValue=''
    },
    //保存
    save(){
      let that = this
      if(this.userInfo.mobile==''){
        this.$message.warning('请输入手机号！')
        return false
      }
      if(this.userInfo.password==''){
        this.$message.warning('请输入密码！')
        return false
      }
      if(this.userInfo.codeValue==''){
        this.$message.warning('请输入验证码！')
        return false
      }else{
        if(!validatePassword(this.userInfo.password)){
          this.$message.warning('密码必须包含大小写字母、数字、特殊字符且长度在8位以上！')
          return false
        }else{
          this.$confirm({
            title: "修改密码？",
            content: "将密码修改为:"+that.userInfo.password+"?",
            okText: "确定",
            okType: "danger",
            cancelText: "取消",
            centered: true,
            onOk() {
              that.updatePassword()
            },
            onCancel() {},
          });
        }
      }

    },
    //
    handleOk(){
      this.reasonVisible=false
    },
    // 首次申请
    applySubscribe(){
      this.editForm={
        type: '',
        name: '',
        title: '',
        level:'',
        hostype:'',
        logo: '',
        describe: '',
        isUse: true,
        bussinessUrl:'',
        frontUrl:'',
        backUrl:'',
        userName:'',
        userIdNum:'',
        phone:'',
        code:'',
      }
      this.subsState='create'
    },
    // 再次申请
    applyAgain(){
      // console.log(this.subscribeInfo[0])
      this.subsId=this.subsDataList[0].subscribeId
      this.editForm={
        type: this.subsDataList[0].typeId,
        name: this.subsDataList[0].name,
        title: this.subsDataList[0].subtitle,
        level:'',
        hostype:'',
        logo: this.subsDataList[0].logoUrl,
        describe: this.subsDataList[0].desc,
        isUse: true,
        bussinessUrl:this.subscribeInfo[0].businessLicenseUrl,
        frontUrl:this.subscribeInfo[0].identityCardFrontUrl,
        backUrl:this.subscribeInfo[0].identityCardBackUrl,
        userName:this.subscribeInfo[0].contactName,
        userIdNum:this.subscribeInfo[0].identityCardNumber,
        phone:this.subscribeInfo[0].contactMobile,
        code:'',
      }
      this.subsState='edit'
    },

    /** 接口*/
    getSubscriptionInfo(){
      let form={
        Authorization:localStorage.getItem('token')
      }
      getSubsInfo(form).then(res=>{
        if(res.status&&res.data.hasOwnProperty('subscribe')){

          this.subsDataList=res.data.subscribe
          this.subscribeInfo=res.data.subscribeInfo
        }
      }).catch(()=>{
        console.log('获取用户信息失败')
      })
    },
    updatePassword(){
      let mdpass=''
      getMD5(this.userInfo.password.trim(), function (md5) {
        mdpass = md5;
      });
      let form={
        codeKey:this.userInfo.codeKey,
        codeValue: this.userInfo.codeValue,
      }
      let data={
        mobile:this.userInfo.mobile,
        password:mdpass,
        email:this.userModel!={}?this.userModel.email:'',
        likeName:this.userModel!={}?this.userModel.likeName:''
      }
      forgetPassword(form,data).then(res=>{
        if(res.status){
          localStorage.removeItem("token");
          localStorage.removeItem("userinfo");
          sessionStorage.removeItem('userModel')
          sessionStorage.removeItem('subscribe')
          sessionStorage.removeItem('subscribeInfo')
          sessionStorage.removeItem('dyhState')
          sessionStorage.removeItem('subsId')
          // 刷新页面 通过路由守卫回到登陆页
          this.$router
              .go(0)
              .catch((e) => {
                console.log(e)
              });
        }else{
          this.$message.error('发生错误！')
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>